import { render, staticRenderFns } from "./ReservationAlertModal.vue?vue&type=template&id=66767b74&scoped=true&lang=pug"
import script from "./ReservationAlertModal.vue?vue&type=script&lang=js"
export * from "./ReservationAlertModal.vue?vue&type=script&lang=js"
import style0 from "./ReservationAlertModal.vue?vue&type=style&index=0&id=66767b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66767b74",
  null
  
)

export default component.exports